export const getById = (id: string) => document.getElementById(id);

export const getInput = (parent: HTMLElement, name: string) => parent.querySelector(`[name="${name}"]`) as HTMLInputElement;

export const getInputByName = (form: HTMLFormElement, name: string) => form.elements.namedItem(name) as HTMLInputElement;

export const getByClassName = (parent: HTMLElement, className: string) => parent.getElementsByClassName(className)[0];